// packages block
import { Avatar, Box, IconButton, Menu, MenuItem } from '@mui/material';
import { FC, useContext, useRef, useState } from 'react';
// others block
import { PrimaryDots } from '../../assets/images';
import { AppContext } from '../../context';
import { ActionType } from '../../context/AppContextReducer';
import { CustomTaskMenuProps } from '../../interfaceTypes';
import { anchorOrigin, menuPaperStyles, transformOrigin } from '../../theme/styleConstants';

export const CustomTasksMenu: FC<CustomTaskMenuProps> = ({ task, setCurrentCustomTask }): JSX.Element => {
  const [open, setOpen] = useState<boolean>(false);
  const { isEdit, dispatch: appDispatch, isDeleteOpen } = useContext(AppContext)
  const { id } = task || {}

  const handleClick = () => setOpen(!open);

  const handleClose = () => setOpen(false);

  const anchorRef = {
    [id!]: useRef<HTMLButtonElement>(null),
  };

  const handleViewModal = () => {
    handleClose();
    appDispatch({ type: ActionType.SET_IS_EDIT, isEdit: !isEdit })
    setCurrentCustomTask && setCurrentCustomTask(task)
  }

  const handleDeleteModal = () => {
    handleClose();
    appDispatch({ type: ActionType.SET_IS_DELETE_OPEN, isDeleteOpen: !isDeleteOpen })
    setCurrentCustomTask?.(task)
  }

  return (
    <Box>
      <IconButton
        ref={anchorRef[id!]}
        id={`long-button-${id}`}
        aria-controls={`long-menu-${id}`}
        aria-haspopup="true"
        onClick={handleClick}
      >
        <Avatar sx={{ bgcolor: 'transparent' }}>
          <PrimaryDots />
        </Avatar>
      </IconButton>

      <Menu
        id={`long-menu-${id}`}
        anchorEl={anchorRef[id!].current}
        open={open}
        anchorOrigin={anchorOrigin}
        transformOrigin={transformOrigin}
        onClose={handleClose}
        PaperProps={menuPaperStyles}
      >
        <MenuItem onClick={handleViewModal}>View</MenuItem>
        <MenuItem onClick={handleDeleteModal} color='primary.main'>Delete</MenuItem>
      </Menu>
    </Box>
  );
};
